if (!customElements.get('hero-background-video')) {
  customElements.define('hero-background-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const update = () => {
        const paused = this.video.paused;
        this.button.toggleAttribute('data-playing', !paused);
        this.button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} background video`);
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) this.play();
        else this.video.pause();
      }, options);
      this.video.addEventListener('play', update, options);
      this.video.addEventListener('pause', update, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video.pause();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.resumeWhenVisible = !this.video.paused;
          this.video.pause();
        } else if (this.resumeWhenVisible && !this.motion.matches) {
          this.resumeWhenVisible = false;
          this.play();
        }
      }, options);
      this.button.hidden = false;
      if (!this.motion.matches && !navigator.connection?.saveData) this.play();
    }

    play() {
      const source = this.video.querySelector('source');
      if (!source.hasAttribute('src')) {
        source.src = window.matchMedia('(max-width: 749px)').matches
          ? source.dataset.mobileSrc || source.dataset.src
          : source.dataset.src;
        this.video.load();
      }
      this.video.muted = true;
      this.video.play().catch(() => {});
    }

    disconnectedCallback() {
      this.abort.abort();
      this.video.pause();
    }
  });
}
